module.exports = __webpack_public_path__ + "static/img/15.97fa27a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/eng/15.png
// module id = /Xua
// module chunks = 0